import { render } from "./Assistants.vue?vue&type=template&id=0a25c11a&scoped=true"
import script from "./Assistants.vue?vue&type=script&lang=ts"
export * from "./Assistants.vue?vue&type=script&lang=ts"

import "./Assistants.vue?vue&type=style&index=0&id=0a25c11a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a25c11a"

export default script